import type { QuadriInCostruzione } from './costruzione'
import { avviso, type Diagnostica } from './diagnostica'
import type { DatiPeriodo } from './ingresso'
import type { QuadroModello } from './modello'

/**
 * Correzione manuale dei kWh calcolati, senza toccare le letture. Si applica
 * prima di scaglioni e accisa, quindi l'accisa segue il valore corretto.
 *
 * NON si propaga ai quadri derivati da formula: gira DOPO `righeDaFormule`
 * (`quadri.ts`), quindi un override su un quadro che compare in un consumo per
 * differenza lascia il derivato sul valore originale. E' deliberato — l'override e'
 * una rettifica puntuale del dichiarante, non un ricalcolo a monte — e comporta che
 * l'XML possa risultare internamente incoerente (la fixture 04 lo pinna: marzo
 * dichiara produzione 6.000, ceduta 2.500, uso proprio 5.000). Chi sovrascrive si
 * assume l'incoerenza; per propagarla servirebbe spostare questa chiamata prima
 * delle formule e rifare le fixture.
 */
export function applicaOverride(q: QuadriInCostruzione, dati: DatiPeriodo): Diagnostica[] {
  const diagnostiche: Diagnostica[] = []
  for (const [quadro, perChiave] of Object.entries(dati.override)) {
    const righe = q[quadro as QuadroModello] ?? []
    for (const [chiave, perMese] of Object.entries(perChiave)) {
      for (const [meseTesto, kwh] of Object.entries(perMese)) {
        const mese = Number(meseTesto)
        const bersagli = righe.filter(
          (r) => r.mese === mese && (r.matricola === chiave || (r.progr !== undefined && String(r.progr) === chiave)),
        )
        if (bersagli.length === 0) {
          diagnostiche.push(avviso('OVERRIDE_SENZA_RIGA', `nessuna riga ${quadro} ${chiave} nel mese ${mese}`, { mese }))
        }
        for (const r of bersagli) r.kwh = kwh
      }
    }
  }
  return diagnostiche
}
